// extracted by mini-css-extract-plugin
export default {"productCarousel":"U0-z"};